<div [ngStyle]="{ height: height, 'max-height': maxHeight }" class="msp-table-component-container">
	<div class="search-container" *ngIf="searchable">
		<input
			type="text"
			[placeholder]="labels.lbl_geral_pesquisar"
			[value]="searchText"
			(input)="onSearchChange($any($event.target).value)" />
	</div>

	<div class="msp-table-container" #horizontalScrollContainer *ngIf="_mspTableConfig.tableViewType === 'table'">
		<div class="header-container" [ngStyle]="{ width: header.length > 4 ? 20 * header.length + 'dvw' : 'unset' }">
			<div
				[ngStyle]="{
					width: cellHeader.colWidth ? cellHeader.colWidth : header.length > 4 ? '20dvw' : 100 / header.length + '%',
				}"
				[ngClass]="{ highlight: _sortBy === cellHeader.name }"
				[title]="
					cellHeader.colType === 'time'
						? cellHeader.value + ' \'HHH:MM:SS\''
						: cellHeader.colType === 'date'
							? cellHeader.value + ' \'' + labels[ProfileService.getDateTimeFullFormatLabel()] + '\''
							: cellHeader.value
				"
				(click)="changeSort(cellHeader.name)"
				*ngFor="let cellHeader of header">
				<span>{{ labels[cellHeader.value] ? labels[cellHeader.value] : cellHeader.value }}</span>
				<span [ngClass]="{ up: _sortBy === cellHeader.name && !_sortDown }">
					<fa-icon
						*ngIf="cellHeader.colType !== 'icon'"
						[icon]="_sortBy !== cellHeader.name || _sortDown ? _icons['faSortDown'] : _icons['faSortUp']"></fa-icon>
				</span>
			</div>
			<!-- <div class="table-options" (click)="_isTableOptionOpen = !_isTableOptionOpen" *ngIf="!tableOnly">
                <fa-icon [icon]="_icons['faEllipsisVertical']"></fa-icon>
            </div> -->
		</div>

		<div class="body-container" [ngStyle]="{ width: header.length > 4 ? 20 * header.length + 'dvw' : 'unset' }" *ngIf="!isLoading">
			<a
				class="table-item"
				[ngClass]="{ odd: index % 2 === 1, 'last-selected': markLastSelectedItem && _lastSelectedItem === tableLine }"
				(click)="_lastSelectedItem = tableLine; itemRouterLink === '' ? getItem(index) : null"
				[routerLink]="itemRouterLink !== '' ? goTo(index) : null"
				*ngFor="let tableLine of _displayBody | slice: _paginationStart : _paginationEnd; let index = index">
				<span
					class="span-item"
					[appTooltip]="
						header[jindex].colType === 'date'
							? DateService.formatDate(tableLine[cellName])
							: header[jindex].colType === 'icon'
								? formatIconTooltip(tableLine[cellName])
								: tableLine[cellName]
					"
					[tooltipOrientation]="{ middle: true, top: true }"
					[ngStyle]="{
						padding: itemPadding,
						width: header[jindex]?.colWidth ? header[jindex].colWidth : header.length > 4 ? '20dvw' : 100 / header.length + '%',
					}"
					*ngFor="let cellName of _headerKeys; let jindex = index">
					<ng-container [ngSwitch]="header[jindex].colType">
						<span *ngSwitchCase="'date'">{{ DateService.formatDate(tableLine[cellName]) }}</span>
						<span *ngSwitchCase="'time'">{{ formatTime(tableLine[cellName]) }}</span>
						<span *ngSwitchCase="'boolean'">{{ formatBoolean(tableLine[cellName]) }}</span>
						<span *ngSwitchCase="'multi-input'">{{ formatSpecialCharacter(tableLine[cellName]) }}</span>
						<span *ngSwitchCase="'multi-select'">{{ formatSpecialCharacter(tableLine[cellName]) }}</span>
						<span *ngSwitchCase="'Checkbox'">{{ formatSpecialCharacter(tableLine[cellName]) }}</span>
						<span *ngSwitchCase="'icon'"
							><fa-icon
								class="icon"
								[ngClass]="tableLine[cellName]"
								[icon]="_icons[formatIconName(tableLine[cellName])]"
								*ngIf="tableLine[cellName] && _icons[formatIconName(tableLine[cellName])]"></fa-icon
						></span>
						<span *ngSwitchDefault>{{ tableLine[cellName] }}</span>
					</ng-container>
				</span>
				<span class="table-options"></span>
			</a>
		</div>
		<div
			class="scroll-button left"
			*ngIf="header.length > 4"
			(click)="horizontalScroll($event, 'left')"
			(wheel)="horizontalScroll($event, 'left')"></div>
		<div
			class="scroll-button right"
			*ngIf="header.length > 4"
			(click)="horizontalScroll($event, 'right')"
			(wheel)="horizontalScroll($event, 'right')"></div>

		<div class="body-container" *ngIf="isLoading">
			<cpi-square-post-loading-effect> </cpi-square-post-loading-effect>
		</div>
	</div>

	<div class="msp-box-container" *ngIf="_mspTableConfig.tableViewType === 'box'">
		<div class="body-container">
			<a
				class="table-item"
				[ngStyle]="{ padding: itemPadding }"
				[ngClass]="{ odd: index % 2 === 1, 'last-selected': markLastSelectedItem && _lastSelectedItem === tableLine }"
				(click)="_lastSelectedItem = tableLine; itemRouterLink === '' ? getItem(index) : null"
				[routerLink]="itemRouterLink !== '' ? goTo(index) : null"
				*ngFor="let tableLine of _displayBody | slice: _paginationStart : _paginationEnd; let index = index">
				<div class="dotted-input-container" *ngFor="let cellName of _headerKeys; let jindex = index">
					<span>{{ labels[header[jindex].value] ? labels[header[jindex].value] : header[jindex].value }}</span>
					<ng-container [ngSwitch]="header[jindex].colType">
						<span *ngSwitchCase="'date'">{{ DateService.formatDate(tableLine[cellName]) }}</span>
						<span *ngSwitchCase="'boolean'">{{ formatBoolean(tableLine[cellName]) }}</span>
						<span *ngSwitchCase="'time'">{{ formatTime(tableLine[cellName]) }}</span>
						<span *ngSwitchCase="'icon'"
							><fa-icon
								[icon]="_icons[tableLine[cellName]]"
								*ngIf="tableLine[cellName] && _icons[tableLine[cellName]]"></fa-icon
						></span>
						<span *ngSwitchDefault>{{ tableLine[cellName] }}</span>
					</ng-container>
				</div>
			</a>
			<div class="box-option" (click)="_isTableOptionOpen = !_isTableOptionOpen" *ngIf="!tableOnly">
				<fa-icon [icon]="_icons['faEllipsisVertical']"></fa-icon>
			</div>
		</div>
	</div>

	<div class="table-config-container" *ngIf="_isTableOptionOpen">
		<div class="header">
			<span>{{ labels.lbl_chat_analyst_configuracoes }}</span>
			<span (click)="_headerFilter = ''; _isTableOptionOpen = !_isTableOptionOpen"
				><fa-icon [icon]="_icons['faTimes']"></fa-icon
			></span>
		</div>
		<div class="card-container">
			<span class="title">{{ labels.lbl_itens_da_listagem }}</span>
			<span class="tip">{{
				customHeaders
					? this.labels.lbl_alteracoes_aplicadas_apenas_para_esta_tabela
					: this.labels.lbl_tabela_sem_customizacao_disponivel
			}}</span>
			<div *ngIf="customHeaders">
				<input [placeholder]="labels.lbl_geral_pesquisar" [value]="_headerFilter" (input)="_headerFilter = $event.target.value" />
			</div>
			<div
				class="header-options-container"
				[ngClass]="{ disabled: !customHeaders }"
				(click)="setHeader(item.name)"
				*ngFor="let item of availableHeadersOptions | callback: filterHeader">
				<span>{{ labels[item.value] ? labels[item.value] : item.value }}</span>
				<span><fa-icon [icon]="header.includes(item) ? _icons['faSquareCheck'] : _icons['faSquare']"></fa-icon></span>
			</div>
		</div>
		<div class="card-container">
			<span class="title">{{ labels.lbl_tipo_visualizacao }}</span>
			<div class="table-visualization-container">
				<div class="option" [ngClass]="{ selected: _mspTableConfig.tableViewType === 'table' }" (click)="setTableViewType('table')">
					<span>{{ labels.lbl_geral_tabela }}</span>
					<span><fa-icon [icon]="_icons['faTable']"></fa-icon></span>
				</div>
				<div class="option" [ngClass]="{ selected: _mspTableConfig.tableViewType === 'box' }" (click)="setTableViewType('box')">
					<span>{{ labels.lbl_geral_caixas_2 }}</span>
					<span><fa-icon [icon]="_icons['faTableCellsLarge']"></fa-icon></span>
				</div>
			</div>
		</div>
		<div class="card-container">
			<span class="title">{{ labels.lbl_geral_resultados_por_pagina }}</span>
			<div class="table-visualization-container">
				<div class="option" [ngClass]="{ selected: _mspTableConfig.itemsPerPage === 10 }" (click)="setTableItemsPerPage(10)">
					<span><fa-icon [icon]="_icons['fa1']"></fa-icon><fa-icon [icon]="_icons['fa0']"></fa-icon></span>
				</div>
				<div class="option" [ngClass]="{ selected: _mspTableConfig.itemsPerPage === 20 }" (click)="setTableItemsPerPage(20)">
					<span><fa-icon [icon]="_icons['fa2']"></fa-icon><fa-icon [icon]="_icons['fa0']"></fa-icon></span>
				</div>
				<div class="option" [ngClass]="{ selected: _mspTableConfig.itemsPerPage === 50 }" (click)="setTableItemsPerPage(50)">
					<span><fa-icon [icon]="_icons['fa5']"></fa-icon><fa-icon [icon]="_icons['fa0']"></fa-icon></span>
				</div>
			</div>
		</div>
		<div class="card-container">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_exportar_esta_pagina_excel }}</span>
				<div class="button" (click)="exportTable()">{{ labels.lbl_geral_exportar_dados }}</div>
			</div>
		</div>
	</div>
	<div class="table-config-transition" *ngIf="_isTableOptionOpen"></div>

	<div class="pagination-container inside-height" *ngIf="insidePagination && searchable">
		<cpi-pagination-counter
			[arrayLength]="_displayBody.length"
			[itemsPerPage]="_mspTableConfig.itemsPerPage"
			[setCurrentPage]="selectedPage"
			(start)="_paginationStart = $event"
			(end)="_paginationEnd = $event"
			(getCurrentPage)="selectedPage = $event; emitSelectedPage()">
		</cpi-pagination-counter>
	</div>
</div>

<div class="pagination-container" *ngIf="insidePagination && !searchable">
	<cpi-pagination-counter
		[arrayLength]="_displayBody.length"
		[itemsPerPage]="_mspTableConfig.itemsPerPage"
		[setCurrentPage]="selectedPage"
		(start)="_paginationStart = $event"
		(end)="_paginationEnd = $event"
		(getCurrentPage)="selectedPage = $event; emitSelectedPage()">
	</cpi-pagination-counter>
</div>
